'use client'

import { ArrowLeft } from '@phosphor-icons/react'
import { useRouter } from 'next/navigation'

export function PageBackButton({
  fallbackHref = '/',
  href,
  label = 'Back',
  className = 'flex items-center gap-3 text-lg font-medium text-[#202020]',
}: {
  fallbackHref?: string
  /** When set, this control goes straight to that page instead of browser history. */
  href?: string
  label?: string
  className?: string
}) {
  const router = useRouter()

  const goBack = () => {
    if (href) {
      router.push(href)
      return
    }
    if (typeof window !== 'undefined' && window.history.length > 1) {
      router.back()
    } else {
      router.push(fallbackHref)
    }
  }

  return (
    <button
      type="button"
      onClick={goBack}
      className={className}
    >
      <ArrowLeft size={24} />
      <span>{label}</span>
    </button>
  )
}
